import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default class FontWeight extends BaseOption {
  static userInterfaceComponent = (_, themeId) => {
    const selectOptions = [];
    if (themeId !== undefined) {
      themeStructure.font.weight.forEach(size => {
        selectOptions.push({
          id: { source: "theme.weight", value: size },
          name: camelToTitleCase(size),
          secondaryLabel: BaseOption._getStyleValuePropertiesFromTheme("font.weight", themeId)[size],
        });
      });
    }

    return {
      label: "Font Weight",
      component: inspectorTools.SIMPLE_PICKER,
      props: {
        options: selectOptions,
      },
    };
  };

  static defaultValue = {
    source: "theme.weight",
    value: "standard",
  };

  static convertConfigValueToCompiledValue(configValue, themeId) {
    return BaseOption._getStyleValuePropertiesFromTheme(
      "font.weight",
      themeId,
    )[configValue.value];
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue.value;
  }
}
